export const questionnaireFieldTypeConstante = Object.freeze({
  QUESTION_TYPE_TEXT: 0,
  QUESTION_TYPE_TEXTAREA: 1,
  QUESTION_TYPE_SELECT: 2,
  QUESTION_TYPE_RADIO: 3,
  QUESTION_TYPE_CHECKBOX: 4,
  QUESTION_TYPE_INSTITUTION_LIST: 5,
  QUESTION_TYPE_COMPONENT_LIST: 6,
  QUESTION_TYPE_DEGREE_LIST: 7,
  QUESTION_TYPE_NUMBER: 8,
  QUESTION_TYPE_UFA_LIST: 9,
  QUESTION_TYPE_FILE: 10,
  QUESTION_TYPE_DATE: 11,
  QUESTION_TYPE_DATETIME: 12,
  QUESTION_TYPE_MISSION: 20,
  QUESTION_TYPE_ACTIVITY: 21,
});
